import { Component, input, output } from "@angular/core";
import { PopupNotification } from "src/app/core/models/notifications";

@Component({
  selector: "app-popup-notification-item",
  templateUrl: "./popup-notification-item.component.html",
  styleUrl: "./popup-notification-item.component.scss",
})
export class NotificationItemComponent {
  readonly notification = input<PopupNotification>();
  readonly clicked = output<void>();

  performCallback() {
    this.notification()?.action?.();
    this.clicked.emit();
  }
}
